"use strict";

function homeProducts() {
  var variantInfos = document.querySelectorAll(".c-home-product__info__variant");
  var productImages = document.querySelectorAll(".c-home-product__image");
  if (variantInfos && productImages) {
    variantInfos.forEach(function (variantInfo) {
      variantInfo.addEventListener("click", function (e) {
        var variantId = e.currentTarget.dataset.variantId;
        var productId = e.currentTarget.dataset.productId;
        var otherVariants = e.currentTarget.parentElement.querySelectorAll(".c-home-product__info__variant");
        if (otherVariants) {
          otherVariants.forEach(function (variantInfoItem) {
            variantInfoItem.classList.remove("c-home-product__info__variant--active");
          });
          e.currentTarget.classList.add("c-home-product__info__variant--active");
        }
        if (variantId && productId) {
          productImages.forEach(function (productImage) {
            var productImageId = productImage.dataset.productId;
            if (productImageId) {
              if (productImageId === productId) {
                var productImageVariants = productImage.querySelector(".c-home-product__image__product__variants");
                if (productImageVariants) {
                  if (productImageVariants.childNodes.length === 0) {
                    return;
                  } else {
                    if (!productImage.classList.contains("show-variant")) {
                      productImage.classList.add("show-variant");
                    }
                    var variantImages = productImage.querySelectorAll(".c-home-product__image__primary--variant");
                    if (variantImages) {
                      variantImages.forEach(function (variantImage) {
                        var variantImageId = variantImage.dataset.variantId;
                        if (variantImageId) {
                          if (variantImageId === variantId) {
                            variantImage.classList.add("show-variant-image");
                          } else {
                            variantImage.classList.remove("show-variant-image");
                          }
                        }
                      });
                    }
                  }
                }
              }
            }
          });
        }
        if (window.innerWidth > 1199) {
          e.preventDefault();
        } else {
          window.location.href = e.currentTarget.attr("href");
        }
      });
    });
  }
  var reviewsCounters = document.querySelectorAll(".c-home-product__rating--js");
  if (reviewsCounters) {
    reviewsCounters.forEach(function (reviewsCounter) {
      var api = reviewsCounter.dataset.publicApi;
      var reviewProduct = reviewsCounter.dataset.productId;
      var domain = reviewsCounter.dataset.domain;
      if (!api || !reviewProduct || !domain) {
        return;
      }
      var requestOptions = {
        method: "GET",
        redirect: "follow"
      };
      fetch("https://stamped.io/api/widget/reviews?productId=" + reviewProduct + "&minRating=1&storeUrl=" + domain + "&apiKey=" + api, requestOptions).then(function (response) {
        return response.json();
      }).then(function (results) {
        reviewsCounter.classList.remove("c-home-product__rating--hidden");
        var ratingInfo = reviewsCounter.querySelector(".c-home-product__rating__info");
        var ratingStar = reviewsCounter.querySelector(".c-home-product__rating__star");
        ratingStar.style.setProperty("--rating", results.rating);
        ratingStar.style.setProperty("--rating-max", 5);
        ratingStar.style.setProperty("--rating-decimal", 0.5);
        var reviewText = " Review";
        if (results.total > 1) {
          reviewText = " Reviews";
        }
        ratingInfo.innerHTML = results.total + reviewText;
      }).catch(function (error) {
        reviewsCounter.classList.add("c-home-product__rating--hidden");
      });
    });
  }
}
homeProducts();
window.addEventListener("resize", homeProducts);

document.addEventListener('DOMContentLoaded', function() {
    const container = document.getElementById('productScrollContainer');
    const leftBtn = container.parentElement.querySelector('.scroll-arrow.left');
    const rightBtn = container.parentElement.querySelector('.scroll-arrow.right');

    const card = container.querySelector('.collection-card');
    if (!card) return; // no cards

    const gap = 16; // gap in px (matches CSS)

    function updateButtons() {
      leftBtn.disabled = container.scrollLeft <= 0;
      rightBtn.disabled = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;
    }

    function scrollLeft() {
      const cardWidth = card.offsetWidth + gap;
      container.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    }

    function scrollRight() {
      const cardWidth = card.offsetWidth + gap;
      container.scrollBy({ left: cardWidth, behavior: 'smooth' });
    }

    leftBtn.addEventListener('click', function() {
      scrollLeft();
    });

    rightBtn.addEventListener('click', function() {
      scrollRight();
    });

    container.addEventListener('scroll', updateButtons);

    // Initial check
    updateButtons();
  });